import { render } from "./ImageEditor.vue?vue&type=template&id=49a88d38&scoped=true"
import script from "./ImageEditor.vue?vue&type=script&lang=js"
export * from "./ImageEditor.vue?vue&type=script&lang=js"

import "./ImageEditor.vue?vue&type=style&index=0&id=49a88d38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49a88d38"

export default script